import React from 'react';
import { useParams } from 'react-router-dom';
import KpiPlannedRelease261 from './KpiPlannedRelease261';
import KpiPlannedRelease2611 from './KpiPlannedRelease2611';
import KpiPlannedRelease2620 from './KpiPlannedRelease2620';
import KpiUntaggedPR261 from './KpiUntaggedPR261';
import PlanningRelease252 from './PlanningRelease252';

export default function ReleasesPage() {
  const { release } = useParams();
  const selectedRelease = release || '26-1';

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Contenu des Releases */}
      <div className="max-w-7xl mx-auto py-8 space-y-6">
        {/* Release 26.1 */}
        {selectedRelease === '26-1' && (
          <>
            <KpiPlannedRelease261 />
            <KpiUntaggedPR261 />
          </>
        )}

        {/* Release 26.1.1 */}
        {selectedRelease === '26-1-1' && (
          <>
            <KpiPlannedRelease2611 />
          </>
        )}

        {/* Release 26.2.0 */}
        {selectedRelease === '26-2-0' && (
          <>
            <KpiPlannedRelease2620 />
          </>
        )}

        {/* Release 25.2 */}
        {selectedRelease === '25-2' && (
          <>
            <PlanningRelease252 />
          </>
        )}
      </div>
    </div>
  );
}
